/**
 * The last word, and the honest one.
 *
 * A footer on a games site usually pads itself with store badges and awards.
 * This one states what kikik is, admits how small the catalog is, and gets out
 * of the way.
 */

import { useI18n } from "../i18n";
import { BrandMark } from "./BrandMark";
import type { NavTarget } from "./PortalHeader";

const LINKS: readonly NavTarget[] = ["games", "categories", "learn"];

export function PortalFooter({ onNavigate }: { onNavigate: (target: NavTarget) => void }) {
  const { t } = useI18n();

  return (
    <footer className="pfooter">
      <div className="shell pfooter__inner">
        <div className="pfooter__brand">
          <BrandMark className="chip--sm" />
          <p className="pfooter__blurb">{t("portal.footer.blurb")}</p>
        </div>

        <nav className="pfooter__nav" aria-label={t("portal.nav.label")}>
          {LINKS.map((target) => (
            <button key={target} type="button" className="linkbtn" onClick={() => onNavigate(target)}>
              {t(`portal.nav.${target}`)}
            </button>
          ))}
        </nav>

        <p className="pfooter__honest">{t("portal.footer.honest")}</p>
        <p className="pfooter__made">{t("portal.footer.madeIn")}</p>
      </div>
    </footer>
  );
}
